/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */
/* global Granite */

import { Component, registerComponent } from 'js/component.js';
import { getBreakpointMediaQuery } from 'js/constants.js';

const componentName = 'product-compare-table';
const productDetailServletEndpoint = '/bin/rockwell-automation/product-details';
const addToBomEndpoint = 'https://www.rockwellautomation.com/my/bom?catalogNumber=${catalogNumber}';
const backupImage = 'https://www.rockwellautomation.com/product-images/${sku}/${sku}.jpg';
const productDetailPath = '/products/details.${catalogNumber}.html';

const COPY_ICON_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="13" height="16" viewBox="0 0 13 16" fill="none" aria-hidden="true">
        <path d="M12.896 7.22424L11.0824 5.24391C11.0455 5.20361 11.0006 5.17144 10.9507 5.14944C10.9008 5.12744 10.8469 5.1161 10.7924 5.11611H8.60171V2.37639C8.60159 2.27705 8.56449 2.18135 8.49771 2.10813L6.68409 0.127797C6.64718 0.0874928 6.60236 0.0553252 6.55246 0.033328C6.50255 0.0113307 6.44865 -1.7713e-05 6.39416 2.07517e-08H0.393923C0.289448 2.07517e-08 0.189252 0.0417282 0.115377 0.116005C0.0415025 0.190282 0 0.291023 0 0.396066V10.4878C0 10.7064 0.176478 10.8839 0.393923 10.8839H4.39776V15.6039C4.39776 15.8226 4.57424 16 4.79168 16H12.6061C12.7105 16 12.8107 15.9583 12.8846 15.884C12.9585 15.8097 13 15.709 13 15.6039V7.49251C13.0006 7.39304 12.9634 7.2971 12.896 7.22424ZM4.39776 5.51218V10.0923H0.787847V0.792132H5.66934V3.07453C5.66934 3.29315 5.84582 3.47059 6.06327 3.47059H7.81439V5.11559H4.79168C4.6872 5.11586 4.58709 5.15776 4.51326 5.23209C4.43943 5.30642 4.3979 5.40713 4.39776 5.51218ZM12.2127 15.2079H5.18561V5.90772H10.0676V8.19011C10.0676 8.40874 10.2441 8.58618 10.4616 8.58618H12.2127V15.2079Z" fill="currentColor"/>
        <path d="M7.138 8.042C7.03854 8.042 6.94316 8.08151 6.87284 8.15183C6.80251 8.22216 6.763 8.31754 6.763 8.417C6.763 8.51646 6.80251 8.61184 6.87284 8.68217C6.94316 8.75249 7.03854 8.792 7.138 8.792H8.811C8.91046 8.792 9.00584 8.75249 9.07617 8.68217C9.14649 8.61184 9.186 8.51646 9.186 8.417C9.186 8.31754 9.14649 8.22216 9.07617 8.15183C9.00584 8.08151 8.91046 8.042 8.811 8.042H7.138ZM6.763 10.39C6.763 10.5425 6.8545 10.672 6.985 10.731C7.03301 10.7531 7.08517 10.7646 7.138 10.765H9.9365C10.036 10.765 10.1313 10.7255 10.2017 10.6552C10.272 10.5848 10.3115 10.4895 10.3115 10.39C10.3115 10.2905 10.272 10.1952 10.2017 10.1248C10.1313 10.0545 10.036 10.015 9.9365 10.015H7.138C7.03854 10.015 6.94316 10.0545 6.87284 10.1248C6.80251 10.1952 6.763 10.2905 6.763 10.39ZM9.9365 12.008H7.138C7.03854 12.008 6.94316 12.0475 6.87284 12.1178C6.80251 12.1882 6.763 12.2835 6.763 12.383C6.763 12.4825 6.80251 12.5778 6.87284 12.6482C6.94316 12.7185 7.03854 12.758 7.138 12.758H9.9365C10.036 12.758 10.1313 12.7185 10.2017 12.6482C10.272 12.5778 10.3115 12.4825 10.3115 12.383C10.3115 12.2835 10.272 12.1882 10.2017 12.1178C10.1313 12.0475 10.036 12.008 9.9365 12.008Z" fill="currentColor"/>
    </svg>`;

export class ProductCompareTable extends Component {
    elements = {
        // Display
        container: this.element.querySelector(`.${componentName}__container`),
        header: this.element.querySelector(`.${componentName}__header`),
        productGrid: this.element.querySelector(`.${componentName}__grid`),
        gridContainer: this.element.querySelector(`.${componentName}__grid-container`),
        gridHeader: this.element.querySelector(`.${componentName}__grid-header`),
        gridHeaderContainer: this.element.querySelector(`.${componentName}__grid-header-container`),
        gridHeaderRow: this.element.querySelector(`.${componentName}__grid-header-row`),
        gridHeaderCellTemplate: this.element.querySelector(`.${componentName}__grid-header-cell--template`),
        closeIcon: this.element.querySelector(`.${componentName}__close-icon`),
        openIcon: this.element.querySelector(`.${componentName}__open-icon`),
        placeholder: this.element.querySelector(`.${componentName}__placeholder`),
        loadingContainer: this.element.querySelector(`.${componentName}__loading-container`),
        loadingHeader: this.element.querySelector(`.${componentName}__loading-header`),
        loadingRows: this.element.querySelector(`.${componentName}__loading-rows`),
        // Actions
        actions: this.element.querySelector(`.${componentName}__actions`),
        backButton: this.element.querySelector(`.${componentName}__back-button`),
        hideSimilaritiesCheckbox: this.element.querySelector(`.${componentName} #hide-similarities`),
        highlightDifferencesCheckbox: this.element.querySelector(`.${componentName} #highlight-differences`),
        // emailLink: this.element.querySelector(`.${componentName}__email-link`),
        // printButton: this.element.querySelector(`.${componentName}__print-button`),
    };

    state = {
        userCompareData: [],
        compareValues: [],
        componentOffset: 0,
        locale: document.documentElement.lang ? document.documentElement.lang.toLocaleLowerCase() : 'en-us',
    };

    constants = {
        app: '',
        language: 'en',
        countryCode: 'us',
        defaultImage: 'https://www.rockwellautomation.com/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/image_unavailable.svg',
        ssDefaultImage: '/etc.clientlibs/rockwell-aem-base/clientlibs/clientlib-base/resources/icons/ss_image_unavailable.svg',
        defaultCompareValues: [
            {
                label: (typeof Granite === 'object' && Granite.I18n) ? Granite.I18n.get('Brand') : 'Brand',
                value: 'brand'
            },
        ],
        subnavDesktopHeight: 50,
        subnavMobileHeight: 60,
        headerDesktopHeight: 72,
        headerMobileHeight: 56,
        noWhitespaceUnits: ['%'],
    };

    getDefaultImage = () => {
        return this.constants.app === 'SS' ? this.constants.ssDefaultImage : this.constants.defaultImage;
    };

    createLoadingSkeleton = (numProducts) => {
        if (!this.elements.loadingHeader || !this.elements.loadingRows) return;

        // Clear existing content
        this.elements.loadingHeader.innerHTML = '';
        this.elements.loadingRows.innerHTML = '';

        // Create loading header with product placeholders
        let headerHTML = '';
        for (let i = 0; i < numProducts; i++) {
            headerHTML += `
                <div class="${componentName}__loading-product ${componentName}__loading-product-header">
                    <div class="${componentName}__loading-product-container">
                        <div class="${componentName}__loading-skeleton ${componentName}__loading-image"></div>
                        <div class="${componentName}__loading-product-info">
                            <div class="${componentName}__loading-skeleton ${componentName}__loading-catalog-number"></div>
                            <div class="${componentName}__loading-skeleton ${componentName}__loading-title"></div>
                            <div class="${componentName}__loading-skeleton ${componentName}__loading-description"></div>
                        </div>
                    </div>
                </div>
            `;
        }
        this.elements.loadingHeader.innerHTML = `
            <div class="${componentName}__loading-header-container">
                <div class="${componentName}__loading-header-grid">
                    ${headerHTML}
                </div>
            </div>
        `;

        // Create loading rows (typically 8 comparison rows)
        let rowsHTML = '';
        for (let row = 0; row < 8; row++) {
            rowsHTML += `
                <div class="${componentName}__loading-row">
                    <div class="${componentName}__loading-row-header">
                    </div>
                    <div class="${componentName}__loading-row-cells">`;

            for (let cell = 0; cell < numProducts; cell++) {
                rowsHTML += `<div class="${componentName}__loading-cell-container">
                                <div class="${componentName}__loading-skeleton ${componentName}__loading-cell"></div>
                            </div>`;
            }

            rowsHTML += `
                    </div>
                </div>
            `;
        }
        this.elements.loadingRows.innerHTML = rowsHTML;
    };

    showSSLoadingState = () => {
        if (this.constants.app === 'SS' && this.elements.loadingContainer && this.state.userCompareData.length > 0) {
            this.createLoadingSkeleton(this.state.userCompareData.length);
            this.elements.loadingContainer.style.display = 'block';
            this.elements.productGrid.style.display = 'none';
            this.elements.gridHeader.style.display = 'none';
            this.elements.placeholder.classList.add('hidden');
        }
    };

    hideSSLoadingState = () => {
        if (this.constants.app === 'SS' && this.elements.loadingContainer) {
            this.elements.loadingContainer.style.display = 'none';
            this.elements.productGrid.style.display = 'table';
            this.elements.gridHeader.style.display = 'table';
        }
    };

    getProducts = async (catalogNumbers) => {
        try {
            const response = await fetch(`${productDetailServletEndpoint}?app=${this.constants.app}&catalogNumber=${catalogNumbers.join(',')}&countryCode=${this.constants.countryCode}`);
            const responseJson = await response.json();
            if (!Array.isArray(responseJson)) {
                return [responseJson];
            } else {
                return responseJson;
            }
        } catch (error) {
            console.warn('Error:', error);
            return [];
        }
    };

    getCompareValues = (products) => {
        const compareValues = [];
        products.forEach((product) => {
            if (product.classificationFeaturesArray) {
                product.classificationFeaturesArray.forEach((feature) => {
                    if (!compareValues.find((compareValue) => compareValue.value === feature.classification_name) && feature.value !== undefined && feature.value !== null && feature.value !== '') {
                        compareValues.push({ label: this.getTranslatableProductField(feature, 'translation_name', 'classification_name', '', this.constants.language), value: feature.classification_name });
                    }
                });
            }
            if (product.sustainability) {
                product.sustainability.filter((sustainability) => sustainability.group === 'Lifecycle Assessment').forEach((feature) => {
                    if (!compareValues.find((compareValue) => compareValue.value === feature.classification_name) && feature.value !== undefined && feature.value !== null && feature.value !== '') {
                        compareValues.push({ label: this.getTranslatableProductField(feature, 'translation_name', 'name', '', this.constants.language), value: feature.name });
                    }
                });
            }
        });
        return compareValues;
    };

    createGridHeader = (products) => {
        this.elements.gridHeaderRow.innerHTML = '';
        products.forEach((product) => {
            const productCell = this.elements.gridHeaderCellTemplate.cloneNode(true);
            this.elements.gridHeaderRow.appendChild(productCell);
            productCell.classList.add(`${componentName}__grid-cell--${product.catalogNumber}`);
            productCell.querySelector(`.${componentName}__product-image`).addEventListener('error', () => {
                const defaultImg = this.getDefaultImage();
                if (image.getAttribute('src') === defaultImg) {
                    return;
                }
                image.setAttribute('src', defaultImg);
            });
            productCell.querySelector(`.${componentName}__product-image`).setAttribute('src', product.picture_url || this.getDefaultImage());
            productCell.querySelector(`.${componentName}__product-image`).alt = this.getTranslatableProductField(product, 'names', 'names_value', '', this.constants.language);
            productCell.querySelector(`.${componentName}__product-remove`).setAttribute('data-catalog-number', product.catalogNumber);
            if ((Object.hasOwn(product, `salesOrg_${this.constants.countryCode}_preferredAvailability`) && !product[`salesOrg_${this.constants.countryCode}_preferredAvailability`])
                || (!Object.hasOwn(product, `salesOrg_${this.constants.countryCode}_preferredAvailability`) && !product.salesOrg_us_preferredAvailability)) {
                productCell.querySelector(`.${componentName}__product-best-selling`).remove();
            }
            productCell.querySelector(`.${componentName}__product-catalog-number`).textContent = product.catalogNumber;
            productCell.querySelector(`.${componentName}__product-name`).textContent = this.getTranslatableProductField(product, 'names', 'names_value', '', this.constants.language);
            productCell.querySelector(`.${componentName}__product-link-info`).href = `${this.constants.app === 'SS' ? '' : `/${this.state.locale}`}${productDetailPath.replace('${catalogNumber}', this.encodeCatalogNumber(product.catalogNumber))}`;
            if (this.constants.app === 'RA') {
                productCell.querySelector(`.${componentName}__product-link-bom`).href = `${addToBomEndpoint.replace('${catalogNumber}', product.catalogNumber)}`;
            } else {
                productCell.querySelector(`.${componentName}__product-link-bom`).remove();
            }
        });
    };

    createGridRow = (products, compareValue) => {
        const gridRowHeader = document.createElement('tr');
        gridRowHeader.classList.add(`${componentName}__grid-row`);
        gridRowHeader.classList.add(`${componentName}__grid-row-header`);
        gridRowHeader.innerHTML = `<td class="${componentName}__grid-cell ${componentName}__grid-row-header-cell" colspan="${products.length}">${compareValue.label}</td>`;
        const gridRow = document.createElement('tr');
        gridRow.classList.add(`${componentName}__grid-row`);
        let rowValues = [];
        products.forEach((product) => {
            let productValue = null;
            if (product[compareValue.value] === true) {
                productValue = 'Yes';
            } else if (product[compareValue.value] === false) {
                productValue = 'No';
            } else if (product[compareValue.value] !== undefined && product[compareValue.value] !== null && product[compareValue.value] !== '') {
                productValue = product[compareValue.value];
            }
            if (!productValue && product.classificationFeaturesArray) {
                product.classificationFeaturesArray.forEach((feature) => {
                    if (feature.classification_name === compareValue.value) {
                        if (feature.value === true) {
                            productValue = 'Yes';
                        } else if (feature.value === false) {
                            productValue = 'No';
                        } else if (feature.value !== undefined && feature.value !== null && feature.value !== '') {
                            productValue = this.getTranslatableProductField(feature, 'translation_value', 'value', '', this.constants.language);
                        }
                    }
                });
            }
            if (!productValue && product.sustainability) {
                product.sustainability.filter((sustainability) => sustainability.group === 'Lifecycle Assessment').forEach((feature) => {
                    if (feature.name === compareValue.value) {
                        if (feature.value === true) {
                            productValue = 'Yes';
                        } else if (feature.value === false) {
                            productValue = 'No';
                        } else if (feature.value !== undefined && feature.value !== null && feature.value !== '') {
                            productValue = this.getTranslatableProductField(feature, 'translation_value', 'value', '', this.constants.language);
                            if (feature.unit !== undefined && feature.unit !== null && feature.unit !== '') {
                                productValue += (this.constants.noWhitespaceUnits.includes(feature.unit) ? '' : ' ') + feature.unit;
                            }
                        }
                    }
                });
            }
            let valueIndex = -1;
            if (productValue === 'Yes') {
                valueIndex = 'true';
            } else if (productValue === 'No') {
                valueIndex = 'false';
            } else if (productValue !== null) {
                let currentMaxIndex = -1;
                rowValues.forEach((previousValue) => {
                    if (previousValue.value === productValue) {
                        valueIndex = previousValue.index;
                    }
                    currentMaxIndex = Math.max(currentMaxIndex, previousValue.index);
                });
                if (valueIndex === -1) {
                    valueIndex = currentMaxIndex + 1;
                }
            }
            rowValues.push({ value: productValue, index: valueIndex });
            gridRow.innerHTML += `<td class="${componentName}__grid-cell ${componentName}__grid-cell--${product.catalogNumber}" data-value-index=${valueIndex}>${productValue || 'N/A'}</td>`;
        });
        if (rowValues.every((value, index, array) => value.value === array[0].value)) {
            gridRow.classList.add(`${componentName}__grid-row--similarity`);
            gridRowHeader.classList.add(`${componentName}__grid-row--similarity`);
        } else {
            gridRow.classList.add(`${componentName}__grid-row--difference`);
            gridRowHeader.classList.add(`${componentName}__grid-row--difference`);
        }
        this.elements.productGrid.appendChild(gridRowHeader);
        this.elements.productGrid.appendChild(gridRow);
    };

    toggleSimilarRows = () => {
        this.elements.hideSimilaritiesCheckbox.setAttribute("data-var", this.elements.hideSimilaritiesCheckbox.checked ? "checked" : "unchecked");
        const similarRows = this.elements.productGrid.querySelectorAll(`.${componentName}__grid-row--similarity`);
        similarRows.forEach((similarRow) => {
            similarRow.classList.toggle('hidden');
        });
    };

    toggleDifferentRows = () => {
        this.elements.highlightDifferencesCheckbox.setAttribute("data-var", this.elements.highlightDifferencesCheckbox.checked ? "checked" : "unchecked");
        const differentRows = this.elements.productGrid.querySelectorAll(`.${componentName}__grid-row--difference`);
        differentRows.forEach((differentRow) => {
            differentRow.classList.toggle('highlight');
        });
    };

    // printGrid = () => {
    //     window.print();
    // };

    removeProduct = (catalogNumber) => {
        const productCells = document.querySelectorAll(`.${componentName}__grid-cell--${catalogNumber}`);
        productCells.forEach((productCell) => {
            productCell.remove();
        });
        this.state.userCompareData = this.state.userCompareData.filter((data) => data !== catalogNumber);
        window.localStorage.setItem('userCompareData', this.state.userCompareData.join(', '));
        if (this.state.userCompareData.length === 0) {
            this.elements.placeholder.classList.remove('hidden');
            this.elements.productGrid.classList.add('hidden');
            this.elements.header.classList.add('hidden');
        } else {
            const productRowHeaders = document.querySelectorAll(`.${componentName}__grid-row-header-cell`);
            productRowHeaders.forEach((productRowHeader) => {
                productRowHeader.colSpan = this.state.userCompareData.length;
            });
        }
    };

    refreshGrid = async (initialLoad = false) => {
        window.dispatchEvent(new CustomEvent('show-loading'));
        this.elements.productGrid.innerHTML = '';

        const urlParams = new URLSearchParams(window.location.search);
        const urlProducts = urlParams.get('products');

        if (urlProducts && initialLoad) {
            this.state.userCompareData = urlProducts.split(',');
        } else {
            this.state.userCompareData = window.localStorage.getItem('userCompareData') ? window.localStorage.getItem('userCompareData').split(', ') : [];
        }

        if (this.state.userCompareData.length === 0) {
            this.elements.placeholder.classList.remove('hidden');
            this.elements.productGrid.classList.add('hidden');
            this.elements.header.classList.add('hidden');
            this.hideSSLoadingState();
        } else {
            this.elements.placeholder.classList.add('hidden');
            this.elements.productGrid.classList.remove('hidden');
            this.elements.header.classList.remove('hidden');
            this.showSSLoadingState();
            const catalogNumbers = this.state.userCompareData;
            const products = await this.getProducts(catalogNumbers);
            if (this.constants.language !== 'en') {
                this.toggleAiTranslationsDisclaimer(products);
            }
            this.state.compareValues = [...this.constants.defaultCompareValues, ...this.getCompareValues(products)];
            this.createGridHeader(products);

            this.state.compareValues.forEach((compareValue) => {
                this.createGridRow(products, compareValue);
            });

            this.elements.gridHeader.querySelectorAll(`.${componentName}__product-remove`).forEach((removeButton) => {
                removeButton.addEventListener('click', (event) => {
                    const catalogNumber = event.currentTarget.getAttribute('data-catalog-number');
                    this.removeProduct(catalogNumber);
                });
            });

            // Update URL with current comparison list
            const newUrl = `${window.location.pathname}?products=${this.state.userCompareData.join(',')}`;
            window.history.replaceState(null, '', newUrl);

            // Sync to localStorage
            window.localStorage.setItem('userCompareData', this.state.userCompareData.join(', '));
            this.hideSSLoadingState();
        }
        this.initTooltips();

        window.dispatchEvent(new CustomEvent('hide-loading'));
    };

    // Calculate top offset of component
    calculateComponentOffset = () => {
        let offset = 0;
        let subnavOffset = document.querySelector('.sub-nav') ? this.constants.subnavDesktopHeight : 0;
        // [LEGACY BREAKPOINT: width < 1280px -> getBreakpointMediaQuery('down', 'large')]
        if (subnavOffset !== 0 && getBreakpointMediaQuery('down', 'large').matches) {
            subnavOffset = this.constants.subnavMobileHeight;
        }
        // [LEGACY BREAKPOINT: width < 1024px -> getBreakpointMediaQuery('down', 'medium')]
        const headerOffset = getBreakpointMediaQuery('down', 'medium').matches ? this.constants.headerMobileHeight : this.constants.headerDesktopHeight;
        if (subnavOffset === 0) {
            offset += headerOffset;
        } else {
            offset += subnavOffset;
        }
        return offset;
    };

    resizeHandler = () => {
        const componentOffset = this.calculateComponentOffset();
        if (this.state.componentOffset !== componentOffset) {
            this.state.componentOffset = componentOffset;
            this.element.style.setProperty(
                '--top-offset',
                `${this.state.componentOffset}px`
            );
        }
    };

    encodeCatalogNumber = (catalogNumber) => {
        return catalogNumber.replaceAll('/', '%252F').replaceAll('.', '%252E');
    }

    // Listener to sync horizontal scroll of grid header and container
    syncScrollHeader = (event) => {
        this.elements.gridHeaderContainer.scrollLeft = event.target.scrollLeft;
    };
    syncScrollContainer = (event) => {
        this.elements.gridContainer.scrollLeft = event.target.scrollLeft;
    };

    getTranslatableProductField = (productJson, field, flattenedField, defaultValue, language) => {
        if (productJson[field] && productJson[field] instanceof Array) {
            try {
                for (let i = 0; i < productJson[field].length; i++) {
                    if (productJson[field][i].isocode.toLowerCase() === language.toLowerCase()) {
                        return productJson[field][i].value;
                    }
                }
            } catch (error) {
                console.warn(`Error getting translatable product field ${field} for language ${language}:`, error);
            }
            if (language.toLowerCase() !== 'en') {
                return this.getTranslatableProductField(productJson, field, flattenedField, defaultValue, 'en');
            }
        }
        return productJson[flattenedField] ? productJson[flattenedField] : defaultValue;
    };

    toggleAiTranslationsDisclaimer = (products) => {
        const aiTranslationsDisclaimer = document.querySelector('.ai-translations-disclaimer-text');
        if (aiTranslationsDisclaimer && products.some((product) => product.translate_time)) {
            aiTranslationsDisclaimer.classList.remove('hidden');
        }
    };

    // Share modal state (per-instance)
    modalEl = null;
    copiedTimer = null;
    _boundHandleEsc = null;

    currentPageTitle() {
        const parentEl = document.querySelector('.documentTitle');
        const specificEl = document.querySelector('h1.title');
        const parent = parentEl ? parentEl.textContent.trim() : '';
        const specific = specificEl ? specificEl.textContent.trim() : '';
        if (parent && specific && parent !== specific) return `${parent}: ${specific}`;
        return parent || specific || (document.title && document.title.trim()) || window.location.href;
    }

    openModal() {
        if (!this.modalEl) {
            this.modalEl = this.buildModal();
        }
        const urlInput = this.modalEl.querySelector('#shareModalUrl');
        if (urlInput) {
            urlInput.value = window.location.href;
        }
        const url = window.location.href;
        const params = new URL(url).searchParams;
        const products = params.get("products");
        const subtitle = this.modalEl.querySelector('#shareModalSubtitle');
        if (subtitle) {
            subtitle.textContent = "Compare products: " +products;
        }
        this.resetCopyButton();
        this.modalEl.style.display = 'flex';
        document.body.classList.add('share-modal-open');
        if (!this._boundHandleEsc) this._boundHandleEsc = this.handleEscKey.bind(this);
        document.addEventListener('keydown', this._boundHandleEsc);
        const focusTarget = this.modalEl.querySelector('.share-modal-close');
        if (focusTarget) focusTarget.focus();
    }

    closeModal() {
        if (!this.modalEl) return;
        this.modalEl.style.display = 'none';
        document.body.classList.remove('share-modal-open');
        if (this._boundHandleEsc) {
            document.removeEventListener('keydown', this._boundHandleEsc);
        }
        this.resetCopyButton();
    }

    resetCopyButton() {
        if (this.copiedTimer) {
            clearTimeout(this.copiedTimer);
            this.copiedTimer = null;
        }
        const copyBtn = this.modalEl && this.modalEl.querySelector('#shareModalCopyBtn');
        if (copyBtn) {
            copyBtn.classList.remove('copied');
            const label = copyBtn.querySelector('.share-modal-copy-label');
            if (label) label.textContent = Granite.I18n.get('Copy link');
        }
    }

    handleEscKey(e) {
        if (e.key === 'Escape') {
            this.closeModal();
        }
    }

    buildModal() {
        const overlay = document.createElement('div');
        overlay.id = 'shareModalOverlay';
        overlay.className = 'product-compare-table__share-modal-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-labelledby', 'shareModalTitle');
        overlay.style.display = 'none';

        const dialog = document.createElement('div');
        dialog.className = 'product-compare-table__share-modal-dialog';

        const header = document.createElement('div');
        header.className = 'product-compare-table__share-modal-header';

        const title = document.createElement('h2');
        title.id = 'shareModalTitle';
        title.className = 'product-compare-table__share-modal-title';
        title.textContent = Granite.I18n.get('Share this URL');

        const closeBtn = document.createElement('button');
        closeBtn.type = 'button';
        closeBtn.className = 'product-compare-table__share-modal-close';
        closeBtn.setAttribute('aria-label', Granite.I18n.get('Close'));
        closeBtn.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M2 2l16 16M18 2L2 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>`;
        closeBtn.addEventListener('click', () => this.closeModal());

        header.appendChild(title);

        const body = document.createElement('div');
        body.className = 'product-compare-table__share-modal-body';

        // Page title is shown below the modal header; filled in on open().
        const subtitle = document.createElement('p');
        subtitle.id = 'shareModalSubtitle';
        subtitle.className = 'product-compare-table__share-modal-subtitle';
        body.appendChild(subtitle);

        const urlRow = document.createElement('div');
        urlRow.className = 'product-compare-table__share-modal-url-row';

        const urlInput = document.createElement('input');
        urlInput.type = 'text';
        urlInput.id = 'shareModalUrl';
        urlInput.className = 'product-compare-table__share-modal-url';
        urlInput.readOnly = true;

        const copyBtn = document.createElement('button');
        copyBtn.type = 'button';
        copyBtn.id = 'shareModalCopyBtn';
        copyBtn.className = 'product-compare-table__share-modal-copy';
        copyBtn.innerHTML = `${COPY_ICON_SVG}<span class="share-modal-copy-label">${Granite.I18n.get('Copy link')}</span>`;
        copyBtn.addEventListener('click', () => this.handleCopyClick());

        urlRow.appendChild(urlInput);
        urlRow.appendChild(copyBtn);

        body.appendChild(urlRow);

        dialog.appendChild(header);
        dialog.appendChild(closeBtn);
        dialog.appendChild(body);
        overlay.appendChild(dialog);

        overlay.addEventListener('click', (e) => {
            if (e.target === overlay) {
                this.closeModal();
            }
        });

        document.body.appendChild(overlay);
        return overlay;
    }

    showCopied() {
        const copyBtn = this.modalEl && this.modalEl.querySelector('#shareModalCopyBtn');
        if (!copyBtn) return;
        copyBtn.classList.add('copied');
        const label = copyBtn.querySelector('.share-modal-copy-label');
        if (label) label.textContent = Granite.I18n.get('Link copied');
        if (this.copiedTimer) clearTimeout(this.copiedTimer);
        this.copiedTimer = setTimeout(() => {
            this.resetCopyButton();
        }, 2000);
    }

    handleCopyClick() {
        const urlInput = this.modalEl && this.modalEl.querySelector('#shareModalUrl');
        const value = urlInput ? urlInput.value : window.location.href;

        const fallback = () => {
            if (!urlInput) return;
            urlInput.removeAttribute('readonly');
            urlInput.select();
            try {
                document.execCommand('copy');
                this.showCopied();
            } catch (err) {
                console.error('Copy fallback failed:', err);
            }
            urlInput.setAttribute('readonly', '');
        };

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(value).then(() => this.showCopied()).catch(fallback);
        } else {
            fallback();
        }
    }



    initTooltips = () => {
        const tooltipContainers = document.querySelectorAll(`.${componentName}__product-best-selling`);

        tooltipContainers.forEach(container => {
            const tooltip = container.querySelector(`.${componentName}__tooltip`);

            if (!tooltip) return;

            const containerParent = document.querySelector(`.${componentName}__grid-header-row`);

            // Show tooltip on mouse enter
            container.addEventListener('mouseenter', () => {
                if (container.getBoundingClientRect().right > (window.innerWidth - 160) || container.getBoundingClientRect().right > containerParent.getBoundingClientRect().right) {
                    tooltip.classList.add('tooltip-left');
                } else if (container.getBoundingClientRect().left < 160 || container.getBoundingClientRect().left < (containerParent.getBoundingClientRect().left) + 32) {
                    tooltip.classList.add('tooltip-right');
                } else {
                    tooltip.classList.remove('tooltip-left', 'tooltip-right');
                }
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on mouse leave
            container.addEventListener('mouseleave', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.classList.remove('tooltip-left', 'tooltip-right');
            });

            // Show tooltip on focus (for accessibility)
            container.addEventListener('focus', () => {
                if (container.getBoundingClientRect().right > (window.innerWidth - 160) || container.getBoundingClientRect().right > containerParent.getBoundingClientRect().right) {
                    tooltip.classList.add('tooltip-left');
                } else if (container.getBoundingClientRect().left < 160 || container.getBoundingClientRect().left < (containerParent.getBoundingClientRect().left) + 32) {
                    tooltip.classList.add('tooltip-right');
                } else {
                    tooltip.classList.remove('tooltip-left', 'tooltip-right');
                }
                tooltip.style.opacity = '1';
                tooltip.style.visibility = 'visible';
            });

            // Hide tooltip on blur (for accessibility)
            container.addEventListener('blur', () => {
                tooltip.style.opacity = '0';
                tooltip.style.visibility = 'hidden';
                tooltip.classList.remove('tooltip-left', 'tooltip-right');
            });
        });
    };



    addEventListeners = () => {
        this.elements.hideSimilaritiesCheckbox.addEventListener('change', this.toggleSimilarRows);
        this.elements.highlightDifferencesCheckbox.addEventListener('change', this.toggleDifferentRows);
        // this.elements.printButton.addEventListener('click', this.printGrid);

        document.addEventListener('visibilitychange', () => {
            if (document.visibilityState === 'visible' && window.localStorage.getItem('userCompareData') !== this.state.userCompareData.join(', ')) {
                this.refreshGrid(false);
            }
        });
        window.addEventListener('resize', this.resizeHandler);
        this.elements.gridContainer.addEventListener('scroll', this.syncScrollHeader);
        this.elements.gridHeaderContainer.addEventListener('scroll', this.syncScrollContainer);

        const printButtons = document.querySelectorAll(`.${componentName}__print-button`);
        Array.from(printButtons).forEach((printButton) => {
            printButton?.addEventListener('click', (event) => {
                window.print();
            });
            printButton?.addEventListener('keydown', (event) => {
                if (event.key === 'Enter') {
                    printButton.click();
                }
            });
        });
        const shareButtons = document.querySelectorAll(`.${componentName}__share-button`);
        Array.from(shareButtons).forEach((shareButton) => {
            shareButton?.addEventListener('click', (event) => {
                this.openModal();
            });
        });
        const shareButtonsMob = document.querySelectorAll(`.${componentName}__share-button-mobile`);
        Array.from(shareButtonsMob).forEach((shareButton) => {
            shareButton?.addEventListener('click', (event) => {
                this.openModal();
            });
        });
    };

    initDom = async () => {
        window.dispatchEvent(new CustomEvent('show-loading'));
        if (document.documentElement.lang === 'zh-TW') {
            this.constants.language = 'zh-tw';
        } else if (document.documentElement.lang) {
            this.constants.language = document.documentElement.lang.split('-')[0].toLocaleLowerCase();
        }
        this.constants.countryCode = document.documentElement.lang.split('-')[1].toLowerCase();
        this.constants.app = this.elements.container.getAttribute('data-app') ? this.elements.container.getAttribute('data-app') : 'RA';
        await this.refreshGrid(true);

        if (document.referrer) {
            this.elements.backButton.href = document.referrer;
        } else {
            this.elements.backButton.remove();
        }
        window.dispatchEvent(new CustomEvent('hide-loading'));

        setTimeout(() => {
            this.state.componentOffset = this.calculateComponentOffset();
            this.element.style.setProperty(
                '--top-offset',
                `${this.state.componentOffset}px`
            );
        }, 750);
    };

    /**
     * Initialize Component
     */
    init = async () => {
        await this.initDom();
        this.addEventListeners();
    };
}

registerComponent(`.${componentName}`, ProductCompareTable);
